import { computed, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Tache } from '../../models/taches/gestion-taches.model';
import { UtilisateurCourantService } from '../../services/utilisateurs/utilisateur-courant.service';

export interface PopupUpsertState {
  tache: Tache;
  isUpsertOnly: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TachesPopupControlService {
  private utilisateurCourantService = inject(UtilisateurCourantService);
  private wasLoggedIn = this.utilisateurCourantService.utilisateurCourantEvent.value != null;

  readonly popupListVisible = signal(false);
  readonly popupUpsert = signal<PopupUpsertState | null>(null);

  readonly isPopupOpen = computed(() => this.popupListVisible() || this.popupUpsert() !== null);

  readonly isPopupListeVisible$: Observable<boolean> = toObservable(this.popupListVisible);

  readonly isPopupUpsertVisible$: Observable<PopupUpsertState> = toObservable(this.popupUpsert).pipe(
    filter((state): state is PopupUpsertState => state !== null),
  );

  constructor() {
    this.utilisateurCourantService.utilisateurCourantEvent.subscribe(user => {
      const isLoggedIn = user != null;
      if (!isLoggedIn || !this.wasLoggedIn) {
        this.masquerPopup();
      }
      this.wasLoggedIn = isLoggedIn;
    });
  }

  afficherPopup(): void {
    this.popupUpsert.set(null);
    this.popupListVisible.set(true);
  }

  afficherPopupUpsert(tache: Tache, isUpsertOnly: boolean): void {
    this.popupListVisible.set(false);
    this.popupUpsert.set({ tache, isUpsertOnly });
  }

  masquerPopup(): void {
    this.popupListVisible.set(false);
    this.popupUpsert.set(null);
  }
}
